<template>
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13.3463 3.83058H1.12404L2.48207 1.47667C2.59612 1.28032 2.52793 1.0287 2.33157 0.914648C2.13286 0.800597 1.8836 0.868792 1.76955 1.06632L0.0552616 4.03752C0.0517343 4.0434 0.0529101 4.05045 0.0493827 4.05633C0.021164 4.11277 0 4.17391 0 4.2421C0 4.3103 0.021164 4.37144 0.0493827 4.42905C0.0529101 4.43493 0.0517343 4.44198 0.0552616 4.44786L1.76955 7.41906C1.84597 7.55074 1.98472 7.62482 2.12698 7.62482C2.19636 7.62482 2.2669 7.60718 2.33157 7.56956C2.52793 7.45668 2.59612 7.20506 2.48207 7.00753L1.12404 4.6548H13.3451C16.5585 4.6548 19.1746 7.26973 19.1746 10.4831C19.1746 13.6965 16.5585 16.3115 13.3451 16.3115H9.99765C9.77072 16.3115 9.58613 16.4949 9.58613 16.723C9.58613 16.9511 9.77072 17.1345 9.99765 17.1345H13.3463C17.0135 17.1345 19.9977 14.1516 19.9977 10.4843C19.9977 6.81706 17.0135 3.83058 13.3463 3.83058Z"
      fill="white"
    />
  </svg>
</template>

<script>
export default {
  name: "IconBack",
  data: () => ({
    iconColor: "currentColor",
  }),
};
</script>
